import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Gem, LogIn } from 'lucide-react';

function Login() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('🔵 Début du login avec:', credentials);
      const result = await login(credentials);
      console.log('🔵 Résultat du login:', result);
      
      if (result.success) {
        console.log('✅ Login réussi ! Navigation vers /');
        navigate('/', { replace: true });
      } else {
        console.log('❌ Login échoué:', result.error);
        setError(result.error);
        setLoading(false);
      }
    } catch (err) {
      console.error('❌ Erreur inattendue:', err);
      setError('Erreur inattendue lors de la connexion');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-blue-500 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="bg-purple-600 p-4 rounded-full mb-4">
            <Gem className="h-12 w-12 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800">BOTUHA</h1>
          <p className="text-gray-600 mt-2">Gestion Multi-Boutiques</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" method="post" action="#">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="username-input" className="block text-sm font-medium text-gray-700 mb-2">
              Nom d'utilisateur
            </label>
            <input
              id="username-input"
              name="username"
              type="text"
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck="false"
              required
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Entrez votre nom d'utilisateur"
            />
          </div>

          <div>
            <label htmlFor="password-input" className="block text-sm font-medium text-gray-700 mb-2">
              Mot de passe
            </label>
            <input
              id="password-input"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Entrez votre mot de passe"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition-colors flex items-center justify-center space-x-2 disabled:opacity-50"
          >
            <LogIn className="h-5 w-5" />
            <span>{loading ? 'Connexion...' : 'Se connecter'}</span>
          </button>
        </form>

        {process.env.NODE_ENV === 'development' && (
          <div className="mt-6 text-center text-sm text-gray-600">
            <p>Identifiants par défaut :</p>
            <p className="font-mono mt-1">admin / admin123</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
